'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCardHeader = require('../ContentCardHeader');

var _ContentCardHeader2 = _interopRequireDefault(_ContentCardHeader);

var _ContentCardImage = require('../ContentCardImage');

var _ContentCardImage2 = _interopRequireDefault(_ContentCardImage);

var _ContentCardText = require('../ContentCardText/ContentCardText');

var _ContentCardText2 = _interopRequireDefault(_ContentCardText);

var _withContentCardFooter = require('../../hocs/withContentCardFooter');

var _withContentCardFooter2 = _interopRequireDefault(_withContentCardFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SourcedArticleCard = function SourcedArticleCard(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_ContentCardHeader2.default, {
      iconType: 'read'
    }),
    _react2.default.createElement(_ContentCardImage2.default, {
      alt: props.title,
      src: props.imageURL
    }),
    _react2.default.createElement(_ContentCardText2.default, { text: props.title }),
    props.messengerShareButton
  );
};

SourcedArticleCard.propTypes = {
  imageURL: _propTypes2.default.string.isRequired,
  messengerShareButton: _propTypes2.default.node,
  siteName: _propTypes2.default.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  title: _propTypes2.default.string.isRequired
};

SourcedArticleCard.defaultProps = {
  messengerShareButton: null
};

SourcedArticleCard.displayName = 'SourcedArticleCard';

exports.default = (0, _withContentCardFooter2.default)(SourcedArticleCard);